import demoContractJson from './demo-contract.json';
import type { DemoContract, Scenario } from '../domain/types';

export function loadDemoContract(): DemoContract {
  return structuredClone(demoContractJson) as DemoContract;
}

export function loadDefaultScenario(): Scenario {
  return structuredClone((demoContractJson as DemoContract).scenario);
}
